import "./DashboardTickerCollection.scss"
import { t } from "i18next"
import { DashboardTicker } from "./DashboardTicker"
import { useEffect, useState } from "react"
import { useScreenSize } from "../../../../core/hook/useScreenSize"
import { QualityCheckStatus } from "../../../qualitycheck/model/qualityCheckDtos"
import { QualityChecksSummary } from "../../model/qualityCheckSummaryDto"

interface DashboardTickerContainerProps {
    items: QualityChecksSummary[]
    isExpiredSelected: boolean
    isFinishedSelected: boolean
    isActiveSelected: boolean
    isScheduledSelected: boolean
    onSelectionChanged: (status: QualityCheckStatus) => void
}

export const DashboardTickerCollection: React.FC<DashboardTickerContainerProps> = (props) => {
    const { isXSmall } = useScreenSize()
    const [expiredCount, setExpiredCount] = useState<number>(0)
    const [finishedCount, setFinishedCount] = useState<number>(0)
    const [activeCount, setActiveCount] = useState<number>(0)
    const [scheduledCount, setScheduledCount] = useState<number>(0)
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const scrollableElement = document.querySelector('.content');

        if (!scrollableElement) return;

        const handleScroll = () => {
            const scrolled = scrollableElement.scrollTop > 0
            setIsScrolled(scrolled)
        };


        scrollableElement.addEventListener('scroll', handleScroll);
        return () => scrollableElement.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setExpiredCount(props.items.reduce((acc, item) => acc + item.expired, 0))
        setFinishedCount(props.items.reduce((acc, item) => acc + item.finished, 0))
        setActiveCount(props.items.reduce((acc, item) => acc + item.active, 0))
        setScheduledCount(props.items.reduce((acc, item) => acc + item.scheduled, 0))
    }, [props.items])

    return (
        <div className={`dashboard-ticker-container border-radius-medium card m-05 border-light ${isXSmall ? "mobile" : ""} ${isScrolled ? "scrolled" : ""}`}>
            <DashboardTicker
                title={t("Expired")}
                value={expiredCount}
                containerWidthThreshold={650}
                backgroundColor="expired"
                icon="clock"
                isSelected={props.isExpiredSelected}
                onToggle={() => props.onSelectionChanged(QualityCheckStatus.Expired)} />
            <DashboardTicker
                title={t("Finished")}
                value={finishedCount}
                containerWidthThreshold={650}
                backgroundColor="finished"
                icon="todo"
                isSelected={props.isFinishedSelected}
                onToggle={() => props.onSelectionChanged(QualityCheckStatus.Finished)} />
            <DashboardTicker
                title={t("Active")}
                value={activeCount}
                containerWidthThreshold={650}
                backgroundColor="active"
                icon="checklist"
                isSelected={props.isActiveSelected}
                onToggle={() => props.onSelectionChanged(QualityCheckStatus.Active)} />
            <DashboardTicker
                title={t("Scheduled")}
                value={scheduledCount}
                containerWidthThreshold={650}
                backgroundColor="scheduled"
                icon="bulletlist"
                isSelected={props.isScheduledSelected}
                onToggle={() => props.onSelectionChanged(QualityCheckStatus.Scheduled)} />
        </div>
    )
}
